import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getCampaigns = ({ churchId }) => {
  return axios.get(`/churches/${churchId}/campaigns`);
};

export const useCampaigns = ({ churchId, config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["campaigns", churchId],
    queryFn: () => getCampaigns({ churchId })
  });
};
